var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "padding-bottom", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [_c("app-divider", { attrs: { label: "Área a ser permutada" } })],
            1
          ),
          _vm.inputsExtraCadastro.imovel.numeroTitulo
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "inputDiv",
                      staticStyle: { padding: "0" },
                      attrs: { span: 24 }
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "Imóvel/N° do título"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: { label: "N° do título:" }
                                  }),
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value:
                                          "##################################################",
                                        expression:
                                          "'##################################################'"
                                      }
                                    ],
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { name: "N° do título" },
                                    model: {
                                      value: _vm.imovel.numeroTitulo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.imovel,
                                          "numeroTitulo",
                                          $$v
                                        )
                                      },
                                      expression: "imovel.numeroTitulo"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1353540777
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.inputsExtraCadastro.imovel.nomeImovelPropriedade
            ? _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c(
                    "el-col",
                    { staticStyle: { padding: "0" }, attrs: { span: 24 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "Nome do imóvel/Propriedade"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Nome do imóvel/Propriedade:"
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      name: "Nome do imóvel/Propriedade"
                                    },
                                    model: {
                                      value: _vm.imovel.nomeImovelPropriedade,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.imovel,
                                          "nomeImovelPropriedade",
                                          $$v
                                        )
                                      },
                                      expression: "imovel.nomeImovelPropriedade"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3490304987
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "padding-bottom", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("app-label", {
                attrs: { label: "Causas da impossibilidade de ocupação:" }
              }),
              _c(
                "el-col",
                { staticStyle: { padding: "0" }, attrs: { span: 24 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: "Imóvel/Causas da impossibilidade de ocupação"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("el-input", {
                              staticClass: "input",
                              class: { erro: errors.length },
                              attrs: {
                                type: "textarea",
                                rows: 5,
                                name: "Causas da impossibilidade de ocupação"
                              },
                              model: {
                                value: _vm.imovel.causasImpossibilidadeOcupacao,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.imovel,
                                    "causasImpossibilidadeOcupacao",
                                    $$v
                                  )
                                },
                                expression:
                                  "imovel.causasImpossibilidadeOcupacao"
                              }
                            }),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-454f64b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-454f64b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/AppImovelAreaPermutada.vue
// module id = null
// module chunks = 